import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderList } from 'src/app/app.models';
import { AppService } from 'src/app/app.service';
@Component({
  selector: 'app-oderdetails',
  templateUrl: './oderdetails.component.html',
  styleUrls: ['./oderdetails.component.scss']
})
export class OrderdetailsComponent implements OnInit {
  public id = 0;
  public order: any = [];
  constructor(
    public appService: AppService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    this.activatedRoute.params.subscribe(params => {
      if (params['id']) {
        this.id = params['id'];
        this.getOrderById(this.id);
      }
    });
  }

  public getOrderById(id) {
    this.appService.getOrderById("api/Order/GetOrderById/" + id).subscribe(data => {

      this.order = data;
    });
  }

}
